// extracted by mini-css-extract-plugin
export default {"spinWrapper":"LoadModal_spinWrapper__bVnuM","loadingIconContainer":"LoadModal_loadingIconContainer__diSD4"};